import { updateAll } from '../nodeUpdates/utility'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { NodeBasedUpdates } from '../nodeUpdates/types'
import { allUpdatesAtom, treeAtom, updatingAtom } from './atoms'
import { useCallback } from 'react'

export function useDoUpdates() {
  const { resetTree } = useAtomValue(treeAtom)
  const updatingSetter = useSetAtom(updatingAtom)
  return useCallback(
    async (...updates: NodeBasedUpdates[]) => {
      updatingSetter(true)
      await updateAll(...updates)
      resetTree?.()
      updatingSetter(false)
    },
    [resetTree, updatingSetter],
  )
}

export function useUpdateAll() {
  const nodeUpdates = useAtomValue(allUpdatesAtom)
  const doUpdates = useDoUpdates()
  return useCallback(() => {
    if (!nodeUpdates) return
    return doUpdates(...nodeUpdates)
  }, [nodeUpdates, doUpdates])
}
